<template>
    <component
        :is="href ? 'a' : 'button'"
        v-bind="$attrs"
        :href="href || null"
        :type="href ? null : type"
        :disabled="href ? null : disabled"
        :aria-disabled="href && disabled ? 'true' : null"
        :class="buttonClasses"
        @click="onClick"
    ><slot /></component>
</template>
<script>
export default {
    name: "SbButton",
    emits: ["click"],
    inheritAttrs: false,
    props: {
        variant: { type: String, default: "secondary" },
        size: { type: String, default: null },
        type: { type: String, default: "button" },
        href: { type: String, default: null },
        disabled: { type: Boolean, default: false },
    },
    computed: {
        buttonClasses() {
            return ["btn", `btn-${this.variant}`, this.size && `btn-${this.size}`];
        },
    },
    methods: {
        onClick(event) {
            if (this.disabled) {
                event.preventDefault();
                return;
            }
            this.$emit("click", event);
        },
    },
};
</script>
